import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class UserAccessible extends ApplicationRecord {
  static jsonapiType = "user_accessibles";

  @Attr({ persist: false }) accessibleId: number;

  @Attr({ persist: false }) accessibleType: string;

  @Attr() accessLevel: string;

  @Attr() userId: number;
}

export default UserAccessible;
